import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Badges } from '../../../../AbstractElements';
import { ContextualVariations, Danger, Dark, Light, Primary, secondary, Success, Warning, Info } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const ContextualBadge = () => {
  return (
    <Col sm='12' xl='6'>
      <Card>
        <HeaderCard title={ContextualVariations} />
        <CardBody>
          <Badges color='primary'>{Primary}</Badges>
          <Badges color='secondary'>{secondary}</Badges>
          <Badges color='success'>{Success}</Badges>
          <Badges color='info'>{Info}</Badges>
          <Badges color='warning' className='text-dark'>
            {Warning}
          </Badges>
          <Badges color='danger'>{Danger}</Badges>
          <Badges color='light' className='text-dark'>
            {Light}
          </Badges>
          <Badges color='dark tag-pills-sm-mb'>{Dark}</Badges>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ContextualBadge;
